import { Injectable, inject } from '@angular/core';
import { from, map, Observable } from 'rxjs';
import { DataPlanesApi, DataPlaneDetails } from '@adesso/dataspace-api-client';
import { ADESSO_API_CONFIG } from '../../../../core/api/adesso-api.config';
import { DataPlaneApiPort } from '../ports/data-plane-api.port';
import type { DataPlaneInstance } from '../models/data-plane-instance.model';

@Injectable()
export class AdessoDataPlaneApiAdapter extends DataPlaneApiPort {
  private readonly api = new DataPlanesApi(inject(ADESSO_API_CONFIG));

  getDataPlanes(): Observable<DataPlaneInstance[]> {
    return from(this.api.getAllDataPlanes()).pipe(
      map((res) => (res.data ?? []).map(toDomain))
    );
  }
}

function toDomain(dto: DataPlaneDetails): DataPlaneInstance {
  return {
    id: dto.id ?? '',
    url: dto.url ?? '',
    lastActive: dto.lastActive ?? 0,
    allowedSourceTypes: toArray(dto.allowedSourceTypes),
    allowedDestTypes: toArray(dto.allowedDestTypes),
    allowedTransferTypes: toArray(dto.allowedTransferTypes),
    state: dto.state ?? ''
  };
}

// Generator types collections as Set<string>; at runtime axios delivers a JSON array.
function toArray(set: Set<string> | undefined): string[] {
  return set ? Array.from(set) : [];
}
